import RecentReleases from '../../components/RecentReleases/RecentReleases'
import './Releases.scss'

export default function Releases() {
	return (
		<div>
			<RecentReleases />
		</div>
	)
}